import { render, staticRenderFns } from "./ImportantInfos3Box.vue?vue&type=template&id=fde19d92"
import script from "./ImportantInfos3Box.vue?vue&type=script&lang=js"
export * from "./ImportantInfos3Box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports